import classNames from 'classnames';

const rootCss = ({ palette, spacing }) => ({
  color: palette.text.secondary,
  flex: '0 0 auto',
  marginLeft: spacing(1),
  fontSize: 10,
  lineHeight: 1,
});

export default function MetadataText({ children, className, rootClassName }) {
  return (
    <span className={classNames(className, rootClassName)} css={rootCss}>
      {children}
    </span>
  );
}
